import {ConnectedComponent} from 'lowkey-component'
import {createPeopleState} from '@services/PeopleState'
import {peopleSelectors} from '@store/peopleSlice'

export class PeopleFilter extends ConnectedComponent {

  peopleState = createPeopleState()
  links: HTMLAnchorElement[] = []
  stateName = ''

  constructor(element: HTMLDivElement) {
    super(element)
    this.onClick = this.onClick.bind(this)
  }

  didMount() {
    this.stateName = this.element.dataset['stateName'] || ''
    this.links = [...this.element.querySelectorAll('a')] as HTMLAnchorElement[]
    this.links.map(link => {
      link.addEventListener('click', this.onClick)
    })

    switch (this.stateName) {
      case 'occupation':
        this.observe(peopleSelectors.selectOccupation, (state) => {
          this.render(state)
        })
        break
      case 'intentionality':
        this.observe(peopleSelectors.selectIntentionality, (state) => {
          this.render(state)
        })
        break
      case 'joinType':
        this.observe(peopleSelectors.selectJoinType, (state) => {
          this.render(state)
        })
        break
    }
  }

  render(currentState: string) {
    this.links.map(link => {
      link.classList.remove('active')
      const stateValue = link.dataset['stateValue'] || ''
      if (currentState === stateValue) {
        link.classList.add('active')
      }
    })
  }

  didUnmount() {
    this.links.map(link => {
      link.removeEventListener('click', this.onClick)
    })
  }

  onClick(e: MouseEvent) {
    const target = e.currentTarget as HTMLDivElement
    const stateValue = target.dataset['stateValue'] || ''

    switch (this.stateName) {
      case 'occupation':
        this.peopleState.updateOccupation(stateValue)
        return
      case 'intentionality':
        this.peopleState.updateIntentionality(stateValue)
        return
      case 'joinType':
        this.peopleState.updateJoinType(stateValue)
        return
    }

  }
}
